<!-- Child.vue -->
<template>
  <div class="child">
    <!-- set a variable then trigger a method which calls `$emit()` -->
    <v-text-field
      solo-inverted
      id="child-input"
      name="msg"
      v-model="childMessage"
      v-on:keyup="emitToParent"
      placeholder="Enter the value"
    />
    <!-- Simplest - call `$emit()` inline-->
    <v-btn v-on:click="$emit('increment')" color="primary"
      >Click me to increment!</v-btn>
  </div>
</template>
<script>
export default {
  data() {
    return {
      childMessage: "",
    };
  },
  name: "ChildComp",
  methods: {
    // Define the method that emits data to the parent as the first parameter to `$emit()`.
    // This is referenced in the <template> call in the parent. The second parameter is the payload.
    emitToParent(event) {
      this.$emit("childToParent", this.childMessage);
    },
  },
};
</script>